import { Button, Dropdown, DropdownButton, Modal } from "react-bootstrap";
import moment from "moment";
import { Handle, Position } from "@xyflow/react";
import {
  DEFAULT_USER_IMG_URL,
  MAIN_WEBSITE_URL,
} from "../../constants/Globals";
import { useState } from "react";
import {
  addBranchToStep,
  updateAndThenInfo,
} from "../../services/CollectionsSvc";
import EditDebate from "../pages/EditDebate";
import { DebateDetail } from "../pages/DraftDebate";

const ViewPollBox = ({
  data,
  onAddBranch,
  onNewStep,
  totalSteps,
  onDelete,
  steps = [],
  hideBranchOption,
  hasVotes,
  onEditContent,
  selNetworkId,
}) => {
  const { part, branchOption, branches, andThen } = data || [];
  const debateData = part?.debate || [];
  const [selectedOption, setSelectedOption] = useState(andThen || null);
  const [showDebateAddEditPopup, setShowDebateAddEditPopup] = useState(false);
  const handleAddEditDebate = () => {
    setShowDebateAddEditPopup(true);
  };

  const handleSelectOption = async (selectedStepId) => {
    if (selectedStepId === "end") {
      setSelectedOption(null);
      try {
        if (andThen) {
          await updateAndThenInfo(data.id, 0);
        }
      } catch (error) {
        console.error("Failed to save the selected option:", error);
      }
    } else {
      const nextStep = steps.find(
        (step) => step.id === parseInt(selectedStepId, 10)
      );
      if (nextStep) {
        const nextStepOrder = nextStep.order;
        setSelectedOption({ nextStepId: nextStep.id, nextStepOrder });

        try {
          if (andThen) {
            await updateAndThenInfo(data.id, nextStep.id);
          } else {
            await addBranchToStep(data.id, {
              branchOption: null,
              nextStepId: nextStep.id,
            });
          }
        } catch (error) {
          console.error("Failed to save the selected option:", error);
        }
      } else {
        console.error("Next step not found");
      }
    }
  };

  return (
    <div
      className={
        !branchOption && data?.stepIndex + 1 === totalSteps
          ? "view-poll-box last-step"
          : "view-poll-box"
      }
    >
      <Handle type="target" position={Position.Top} id="top-handle" />
      <Handle type="target" position={Position.Left} id="left-handle" />
      <div
        style={{
          marginRight: "0px",
          backgroundColor: "transparent",
          display: "flex",
          gap: "50px",
        }}
        key={debateData.id}
      >
        <div style={{ width: "350px" }}>
          <div className="debatePreviewSection1">
            {branchOption ? (
              <>
                <div className="user-option-selected-container">
                  <div className="user-option-header">If user select</div>
                  <span
                    className="remove-button"
                    onClick={() => onDelete(data.branchId, "branch")}
                  >
                    Remove
                  </span>
                </div>
                <div className="option-container">{branchOption}</div>
              </>
            ) : (
              <div className="step-number">
                <div className="d-flex justify-content-between px-1">
                  <span className="customLabel fw-bold">Step {data.order}</span>
                  <span
                    className="customLabel remove-button"
                    onClick={() => handleAddEditDebate(data)}
                  >
                    Edit
                  </span>
                  <span
                    className="customLabel remove-button"
                    onClick={() => onDelete(data.id, "step")}
                  >
                    Remove
                  </span>
                </div>
              </div>
            )}
            <div className="debatePreviewInner">
              <div className="debatePreviewHeader inline-content middle">
                <div className="author">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    className="small-dp user-color-green"
                    href={`${MAIN_WEBSITE_URL}/${debateData?.user?.username}`}
                    tabIndex="0"
                  >
                    <img
                      style={{
                        borderColor: debateData?.user?.statusColor,
                      }}
                      data-src=""
                      src={
                        debateData?.user?.avatarObject
                          ? debateData.user.avatarObject.small.location
                          : DEFAULT_USER_IMG_URL
                      }
                      alt={debateData?.user?.name}
                      className="sidedLazyLoad img-circle avatar"
                      onError={(e) => {
                        e.target.src = DEFAULT_USER_IMG_URL;
                      }}
                    />
                  </a>
                  <div className="copy-wrap">
                    <a
                      target="_blank"
                      rel="noreferrer"
                      className="authorname"
                      href={`${MAIN_WEBSITE_URL}/${debateData?.user?.username}`}
                      tabIndex="0"
                    >
                      <h6>{debateData?.user?.name}</h6>
                    </a>
                    <span className="authorhandle">
                      <span className="handler">
                        Posted{" "}
                        {moment(debateData.startedAt).format("MMM DD, YYYY")}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="debatePreviewTitle mt-3">
                {debateData.thesis !== "" ? (
                  <h5>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`${MAIN_WEBSITE_URL}/${debateData?.user?.username}/${debateData?.slug}`}
                    >
                      {debateData?.thesis}
                    </a>
                  </h5>
                ) : (
                  <>
                    <p></p>
                    <p></p>
                    <p></p>
                  </>
                )}
              </div>
              {debateData?.endedAt === null ? null : (
                <span className="lightColorSpan mt-2 d-block">{`Poll ends in ${(Math.floor(moment(debateData.endedAt).diff(moment(), "minutes") / 1440) > 0 ? Math.floor(moment(debateData.endedAt).diff(moment(), "minutes") / 1440) + " day(s) " : Math.floor((moment(debateData.endedAt).diff(moment(), "minutes") % 1440) / 60) > 0 ? Math.floor((moment(debateData.endedAt).diff(moment(), "minutes") % 1440) / 60) + " hour(s) " : Math.floor((moment(debateData.endedAt).diff(moment(), "minutes") % 1440) % 60) > 0 ? Math.floor((moment(debateData.endedAt).diff(moment(), "minutes") % 1440) % 60) + " minute(s)" : "< 1 minute") ? (Math.floor(moment(debateData.endedAt).diff(moment(), "minutes") / 1440) > 0 ? Math.floor(moment(debateData.endedAt).diff(moment(), "minutes") / 1440) + " day(s) " : Math.floor((moment(debateData.endedAt).diff(moment(), "minutes") % 1440) / 60) > 0 ? Math.floor((moment(debateData.endedAt).diff(moment(), "minutes") % 1440) / 60) + " hour(s) " : Math.floor((moment(debateData.endedAt).diff(moment(), "minutes") % 1440) % 60) > 0 ? Math.floor((moment(debateData.endedAt).diff(moment(), "minutes") % 1440) % 60) + " minute(s)" : "< 1 minute") : ""}`}</span>
              )}
              <div className="debatePreviewSides mt-2">
                {debateData?.sides && debateData?.sides.length
                  ? debateData.sides.map((elSides, i) => (
                      <div className="side" key={elSides.id}>
                        <div className="message position-relative">
                          {!isNaN(elSides.sideVotePercentage.toFixed(2)) ? (
                            <div
                              className="percentageBar"
                              style={{
                                width: elSides.sideVotePercentage + "%",
                                background: elSides.sideColor + "26",
                              }}
                            ></div>
                          ) : null}
                          <div
                            className="topDebateSides"
                            style={{
                              borderColor: elSides.sideColor,
                              background: elSides.sideColor + "10",
                            }}
                          >
                            {elSides.text}
                          </div>
                          {!isNaN(elSides.sideVotePercentage.toFixed(2)) ? (
                            <span className="votesPercentage">
                              {elSides.sideVotePercentage.toFixed(2)}%
                            </span>
                          ) : null}
                        </div>
                      </div>
                    ))
                  : null}
              </div>

              <span className="lightColorSpan mt-2 d-block">
                <span>
                  {debateData?.votes} Vote{debateData?.votes !== 1 ? "s" : ""} •{" "}
                  {debateData?.comments} Comment
                  {debateData?.comments !== 1 ? "s" : ""}{" "}
                </span>
              </span>
            </div>
            {showDebateAddEditPopup && (
              <Modal
                show={showDebateAddEditPopup}
                onHide={() => {
                  setShowDebateAddEditPopup(false);
                  onEditContent(true);
                }}
                size="xl"
                backdrop="static"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    {"Edit " + (debateData?.isQuestion ? "Question" : "Poll")}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: "0 24px" }}>
                  {!debateData.isDraft && (
                    <EditDebate
                      isPopup
                      contentIdFromSeq={debateData.id}
                      selNetworkId={selNetworkId}
                      onClose={() => {
                        setShowDebateAddEditPopup(false);
                        onEditContent(true);
                      }}
                    />
                  )}
                  {debateData.isDraft && (
                    <DebateDetail
                      isPopup
                      contentIdFromSeq={debateData.id}
                      selNetworkId={selNetworkId}
                      onClose={() => {
                        setShowDebateAddEditPopup(false);
                        onEditContent(true);
                      }}
                    />
                  )}
                  
                </Modal.Body>
              </Modal>
            )}
          </div>
          {branchOption &&
            branches?.length === 0 &&
            data?.stepIndex + 1 !== totalSteps && (
              <>
                <div className="user-option-selected-container option-container mt-2">
                  <div className="">And then</div>
                  <DropdownButton
                    id="and-then-dropdown"
                    size="md"
                    variant="outline-secondary"
                    title={
                      selectedOption
                        ? selectedOption.nextStepOrder <=
                          data.rootStep.stepOrder
                          ? `Return to Step ${selectedOption.nextStepOrder}`
                          : `Jump to Step ${selectedOption.nextStepOrder}`
                        : "End Sequence"
                    }
                    onSelect={handleSelectOption}
                    disabled={hasVotes}
                  >
                    {steps
                      .filter((step) => step.id !== data.id)
                      .map((step) => (
                        <Dropdown.Item
                          key={step.id}
                          eventKey={step.id.toString()}
                        >
                          Step {step.order}
                        </Dropdown.Item>
                      ))}
                    <Dropdown.Item eventKey="end">End Sequence</Dropdown.Item>
                  </DropdownButton>
                </div>
              </>
            )}
          <div className="add-step-branch-group">
            {!hideBranchOption &&
              (debateData?.isQuestion
                ? branches?.length < 2
                : branches?.length < debateData?.sides?.length) && (
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => onAddBranch(data)}
                >
                  <img
                    src="/branch.svg"
                    alt="branch"
                    className="me-2 add-branch-image"
                  />
                  <span>Add Branch</span>
                </button>
              )}
          </div>
        </div>

        {!branchOption && data?.stepIndex + 1 === totalSteps && (
          <div>
            <div className="add-step-button-container">
              <div className="d-flex justify-content-between px-1">
                <span className="customLabel fw-bold">
                  Add Step {data.order + 1}
                </span>
              </div>
            </div>
            <div className="add-step-branch-group">
              <div className="d-flex justify-content-center border align-items-center add-step-container">
                <Button
                  onClick={() => onNewStep(data)}
                  className="add-step-button"
                >
                  +
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} id="bottom-handle" />
      <Handle type="source" position={Position.Right} id="right-handle" />
    </div>
  );
};

export default ViewPollBox;
